// removed by extract-text-webpack-plugin
module.exports = {"Position":"_2jPmtTX5Eq7kpMVWrO3AV2","ButtonPosition":"_2ACqTqsrJFCL0QIY8GK6Hg","ButtonLoader":"_3re0XgOD7jbY5U-AXiMZb","Loader":"_3gUxNCBeDTB52vPjmgvrKI","Grey":"_3TfcVU9gaomBkkuK0UDmAL","White":"_3m057oExsx7CwPaoP3pQKZ","lds-dual-ring":"_2fj-GyVR4XDA5Odo0TD-Am"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/Loader/styles.module.css
// module id = 590
// module chunks = 0